// Lightweight A/B framework — deterministic per-visitor variant, no UI redesign.
import { getVisitorId } from "./session";
import { track } from "./analytics";

export const EXPERIMENTS = {
  primary_cta: [
    "Find Your Best College in 60 Seconds",
    "Get Your Free AI Recommendation",
    "Start Free AI Counselling",
  ],
};

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Stable variant for a visitor so their experience never flickers.
export function getVariant(expKey) {
  const variants = EXPERIMENTS[expKey] || [];
  if (!variants.length) return { index: 0, value: "", key: `${expKey}:0` };
  const idx = hash(getVisitorId() + expKey) % variants.length;
  return { index: idx, value: variants[idx], key: `${expKey}:${idx}` };
}

export function trackCtaImpression(ctaId, variantKey) {
  track("cta_impression", { cta_id: ctaId, variant: variantKey });
}
export function trackCtaClick(ctaId, variantKey) {
  track("cta_click", { cta_id: ctaId, variant: variantKey });
  track("talk_to_ai_click", { cta_id: ctaId, variant: variantKey });
}
